
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"attribute.dialog.title":"Attributeinstellungen (Arbeitsmappe)","attribute.action.label":"Attributeinstellungen (Arbeitsmappe)","activeAttribute.dialog.title":"Attributeinstellungen (Datensicht)"},"en":{"attribute.dialog.title":"Attribute settings (workbook)","attribute.action.label":"Attribute settings (workbook)","activeAttribute.dialog.title":"Attribute settings (data view)"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();